import React, { useState } from 'react';
import faqItems from '../data/faqItems.json';

const FaqScreen = ({ darkMode }) => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleItem = (index) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <>
      <h2 className={`text-xl font-bold mb-4 ${darkMode ? 'text-white' : ''}`}>Часто задаваемые вопросы</h2>
      <div className={`rounded-lg shadow overflow-hidden ${darkMode ? 'bg-gray-800' : 'bg-white'
        }`}>
        {faqItems.map((item, index) => (
          <div
            key={index}
            className={`${index !== 0 ? (darkMode ? 'border-t border-gray-700' : 'border-t') : ''}`}
          >
            <div
              className={`p-4 flex justify-between items-center cursor-pointer ${expandedItems[index] ? (darkMode ? 'bg-gray-700' : 'bg-gray-100') : ''
                }`}
              onClick={() => toggleItem(index)}
            >
              <h3 className={`font-semibold ${darkMode ? 'text-white' : ''}`}>{item.question}</h3>
              <i className={`fas ${expandedItems[index] ? 'fa-chevron-up' : 'fa-chevron-down'} ${darkMode ? 'text-gray-400' : 'text-gray-600'
                }`}></i>
            </div>
            {expandedItems[index] && (
              <div className={`p-4 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
                <div
                  className={darkMode ? 'text-gray-300' : 'text-gray-600'}
                  dangerouslySetInnerHTML={{ __html: item.answer }}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default FaqScreen;